<template>
    <div style="width: 100%;height: 80px;display: flex;align-items: center;">
        <img  src="@/assets/pdf/logo.jpg" style="width: 120px;height: 40px;padding-left: 30px;">
    </div>
</template>
<script>
</script>
<style scoped>
</style>